import React from 'react'
import { Button, Element } from 'react-bulma-components'
import { Translate } from '../../utils/translations'

interface OwnerCheckFormProps {
  onYes?: () => void
  onNo?: () => void
}

/**
 * Simple form component to ask if user is still owner of the basketball hoop
 * Displays a question with two buttons: Yes and No
 */
const OwnerCheckForm: React.FC<OwnerCheckFormProps> = ({ onYes, onNo }) => {
  return (
    <Element>
      <Element display="flex" justifyContent="center">
        <Button
          color="success"
          size="large"
          onClick={onYes}
          mr={4}
          data-testid="owner-check-yes"
        >
          <Translate value="yes" />
        </Button>

        <Button color="danger" size="large" onClick={onNo} data-testid="owner-check-no">
          <Translate value="no" />
        </Button>
      </Element>
    </Element>
  )
}

export default OwnerCheckForm
